export const adminLogUrls = {
  "/user": "کاربران",
  "/geo": "شهرها",
  "/ticket": "تیکت ها",
  "/log": "رویدادنگاری",
  "/customer": "مشتری",
  "/web-service-profit": "سود وب سرویس ها",
};
export const userRoleItems = [
  "ADMIN",
  "AGENT",
  "CUSTOMER",
  "RECEPTION",
  "SHOP",
];
export const ticketTypeItems = ["OPEN", "ANSWERED", "CLOSED"];
export const logMethodItems = ["GET", "POST", "DELETE", "PUT", "PATCH"];
export const transactionTypeItems = ["DEPOSIT", "WITHDRAWAL", "TRANSFER"];
export const createTransactionTypeItems = ["DEPOSIT", "WITHDRAWAL"];
export const genderTypeItems = ["MALE", "FEMALE"];
export const charter724FlightTypeItems = ["charter", "system"];
export const charter724GenderTypeItems = [1, 2]; // gender 1 man 2 woman
export const charter724SellingTypeItems = [
  "All",
  "Only Iranian",
  "Non Iranian",
];
export const charter724PassengerTypeItems = ["ADL", "CHD", "INF"];
export const flyOrderStatusItems = [
  "PENDING",
  "RESERVED",
  "PAID",
  "CANCELED",
  "WAITING_FOR_ACCEPT_ADMIN",
  "ACCEPTED_WITH_ADMIN",
  "REJECTED_WITH_ADMIN",
];
export const charter724NationalityItems = [1, 2]; // nationality 1 Iranian 2 Non-Iranians
export const charter724NationalityCodeItems = [
  "IRI",
  "IRQ",
  "AFG",
  "ARM",
  "BHR",
  "CHN",
  "IND",
  "KWT",
  "MYS",
  "SYR",
  "TUR",
  "TKM",
  "TJK",
  "QAT",
]; // nationality code. "IRI"://Iran "IRQ"://Iraq "AFG"://Afghanistan "ARM"://Armenia "BHR"://Bahrain "CHN"://China "IND"://India "KWT"://Kuwait "MYS"://Malaysia "SYR"://Syria "TUR"://Turkey "TKM"://Turkmenistan "TJK"://Tajikestan "QAT"://Qatar "IRQ":For other countries
export const charter724AirlineItems = [
  "Varesh",
  "Zagros",
  "taban",
  "saha",
  "ATA",
  "sepehran",
  "Caspian",
  "Kish",
  "IRanair",
  "meraj",
  "Aseman",
  "airtour",
  "Mahan",
  "avaair",
  "chabahar",
  "flypersia",
  "qheshm",
  "pegasus",
  "naft",
  "parsair",
  "yazdair",
];
export const servicesItems = [
  "HALF_CHARGE_ENTRY",
  "HALF_CHARGE_EXIT",
  "SIDE_COSTS",
  "EXTRA_BED",
];
export const categoryItems = [
  "travel",
  "service",
  "household",
  "sustenance",
  "entertainment",
  "lifestyle",
  "education",
  "gift",
];
export const categoryItemsFarsi = [
  "سفر و گردشگری",
  "خدمات کاربردی",
  "خرید روزانه",
  "خرید ارزاق",
  "ورزش و سرگرمی",
  "سبک زندگی",
  "آموزشی",
  "مناسبتی",
];
export const categoryItemsAlias = [
  "گردشگری",
  "کاربردی",
  "خرید",
  "ارزاق",
  "سرگرمی",
  "سبک زندگی",
  "آموزشی",
  "مناسبتی",
];
export const adminPermissions = {
  canTest1: "تست 1",
  canTest2: "تست 2",
  canTest3: "تست 3",
  canTest4: "تست 4",
  canTest5: "تست 5",
  canTest6: "تست 6",
};
export const agentPermissions = {
  canHotel: "هتل",
  canTest2: "تست 2",
  canTest3: "تست 3",
  canTest4: "تست 4",
  canTest5: "تست 5",
  canTest6: "تست 6",
};
export const receptionPermissions = {
  canHotel: "تست 1",
  canTest2: "تست 2",
  canTest3: "تست 3",
  canTest4: "تست 4",
  canTest5: "تست 5",
  canTest6: "تست 6",
};
export const shopPermissions = {
  canHotel: "تست 1",
  canTest2: "تست 2",
  canTest3: "تست 3",
  canTest4: "تست 4",
  canTest5: "تست 5",
  canTest6: "تست 6",
};
export const snappTripBookStateItems = [
  "payment_on",
  "payment_done",
  "payment_verified",
  "canceled_by_user",
  "canceled_by_cs",
  "awaiting_clearance",
  "user_confirmed_info",
];
export const uploadTypeItems = [
  "OTHERS",
  "AVATAR",
  "TICKETS",
  "DOCUMENTS",
  "PASS",
];
export const receptionOrderStatusItems = [
  "PENDING",
  "RESERVED",
  "PAID",
  "CANCELED",
  "WAITING_FOR_ACCEPT_ADMIN",
  "ACCEPTED_WITH_ADMIN",
  "REJECTED_WITH_ADMIN",
  "WAITING_FOR_ACCEPT_AGENT",
  "ACCEPTED_WITH_AGENT",
  "REJECTED_WITH_AGENT",
  "WAITING_FOR_ACCEPT_RECEPTION",
  "ACCEPTED_WITH_RECEPTION",
  "REJECTED_WITH_RECEPTION",
];
export const sortItems = ["asc", "desc"];
export const lastDaysItems = [7, 15, 30, 90, 180, 365];
export const cameraErrorItems = ["NotAllowedError", "NotFoundError"];
export const notificationTypeItems = ["SUCCESS", "ERROR", "INFO", "WARNING"];
export const paymentTypeItems = ["GATEWAY", "CASH"];

//* Start Convert To Text
export const convertTicketTypeToText = (type) => {
  let result = "";
  switch (type) {
    case ticketTypeItems[0]:
      result = "باز";
      break;
    case ticketTypeItems[1]:
      result = "پاسخ داده شده";
      break;
    case ticketTypeItems[2]:
      result = "بسته";
      break;

    default:
      break;
  }
  return result;
};
export const convertLogUrlToText = (type) => {
  if (!type) return;

  const urls = Object.keys(adminLogUrls);
  let result = type;
  for (const url of urls) {
    if (type.includes(url)) result = adminLogUrls[url];
  }
  return result;
};
export const convertLogMethodToText = (type) => {
  let result = "";
  switch (type) {
    case logMethodItems[0]:
      result = "واکشی";
      break;
    case logMethodItems[1]:
      result = "ایجاد";
      break;
    case logMethodItems[2]:
      result = "حذف";
      break;
    case logMethodItems[3]:
      result = "ویرایش";
      break;
    case logMethodItems[4]:
      result = "ویرایش جزئی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertSortToText = (type) => {
  let result = "";
  switch (type) {
    case sortItems[0]:
      result = "صعودی";
      break;
    case sortItems[1]:
      result = "نزولی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertRoleToTitle = (type) => {
  let result = "";
  switch (type) {
    case userRoleItems[0]:
      result = "ادمین ها";
      break;
    case userRoleItems[1]:
      result = "نمایندگان";
      break;
    case userRoleItems[2]:
      result = "مشتری ها";
      break;
    case userRoleItems[3]:
      result = "پذیرنده ها";
      break;
    case userRoleItems[4]:
      result = "فروشگاه ها";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertTransactionTypeToText = (type) => {
  let result = "";
  switch (type) {
    case transactionTypeItems[0]:
      result = "افزایش";
      break;
    case transactionTypeItems[1]:
      result = "کاهش";
      break;
    case transactionTypeItems[2]:
      result = "انتقال";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertGenderTypeToText = (type) => {
  let result = "";
  switch (type) {
    case genderTypeItems[0]:
      result = "مرد";
      break;
    case genderTypeItems[1]:
      result = "زن";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertSnappTripBookStateToText = (type) => {
  let result = "";
  switch (type) {
    case snappTripBookStateItems[0]:
      result = "در حال پرداخت";
      break;
    case snappTripBookStateItems[1]:
      result = "پرداخت انجام شد";
      break;
    case snappTripBookStateItems[2]:
      result = "تأیید پرداخت";
      break;
    case snappTripBookStateItems[3]:
      result = "کنسلی رزرو توسط مشتری";
      break;
    case snappTripBookStateItems[4]:
      result = "کنسلی رزرو توسط اپراتور";
      break;
    case snappTripBookStateItems[5]:
      result = "در انتظار تسویه";
      break;
    case snappTripBookStateItems[6]:
      result = "اطلاعات کامل شده";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertHotelServiceToText = (type) => {
  let result = "";
  switch (type) {
    case servicesItems[0]:
      result = "نیم شارژ ورود";
      break;
    case servicesItems[1]:
      result = "نیم شارژ خروج";
      break;
    case servicesItems[2]:
      result = "هزینه جانبی";
      break;
    case servicesItems[3]:
      result = "تخت اضافه";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertCategoryToText = (type) => {
  let result = "";
  switch (type) {
    case categoryItems[0]:
      result = "سفر و گردشگری";
      break;
    case categoryItems[1]:
      result = "خدمات کاربردی روزانه";
      break;
    case categoryItems[2]:
      result = "خرید لوازم منزل";
      break;
    case categoryItems[3]:
      result = "خرید ارزاق";
      break;
    case categoryItems[4]:
      result = "ورزش، تفریح و سرگرمی";
      break;
    case categoryItems[5]:
      result = "سبک زندگی و خانواده";
      break;
    case categoryItems[6]:
      result = "آموزش و توانمندسازی";
      break;
    case categoryItems[7]:
      result = "هدایای مناسبتی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertCharter724FlightTypeToText = (type) => {
  let result = "";
  switch (type) {
    case charter724FlightTypeItems[0]:
      result = "چارتری";
      break;
    case charter724FlightTypeItems[1]:
      result = "سیستمی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertCharter724AirlineToText = (type) => {
  let result = "";
  switch (type) {
    case charter724AirlineItems[0]:
      result = "وارش";
      break;
    case charter724AirlineItems[1]:
      result = "زاگرس";
      break;
    case charter724AirlineItems[2]:
      result = "تابان";
      break;
    case charter724AirlineItems[3]:
      result = "ساها";
      break;
    case charter724AirlineItems[4]:
      result = "آتا";
      break;
    case charter724AirlineItems[5]:
      result = "سپهران";
      break;
    case charter724AirlineItems[6]:
      result = "کاسپین";
      break;
    case charter724AirlineItems[7]:
      result = "کیش ایر";
      break;
    case charter724AirlineItems[8]:
      result = "ایران ایر";
      break;
    case charter724AirlineItems[9]:
      result = "معراج";
      break;
    case charter724AirlineItems[10]:
      result = "آسمان";
      break;
    case charter724AirlineItems[11]:
      result = "ایران ایرتور";
      break;
    case charter724AirlineItems[12]:
      result = "ماهان";
      break;
    case charter724AirlineItems[13]:
      result = "آوا ایر";
      break;
    case charter724AirlineItems[14]:
      result = "چابهار";
      break;
    case charter724AirlineItems[15]:
      result = "فلای پرشیا";
      break;
    case charter724AirlineItems[16]:
      result = "قشم ایر";
      break;
    case charter724AirlineItems[17]:
      result = "پگاسوس";
      break;
    case charter724AirlineItems[18]:
      result = "کارون";
      break;
    case charter724AirlineItems[19]:
      result = "پارس ایر";
      break;
    case charter724AirlineItems[20]:
      result = "یزد ایر";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertCharter724PassengerTypeToText = (type) => {
  let result = "";
  switch (type) {
    case charter724PassengerTypeItems[0]:
      result = "بزرگسال > 12";
      break;
    case charter724PassengerTypeItems[1]:
      result = "کودک 2~12";
      break;
    case charter724PassengerTypeItems[2]:
      result = "0~2 نوزاد";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertCharter724GenderTypeToText = (type) => {
  let result = "";
  switch (type) {
    case charter724GenderTypeItems[0]:
      result = "آقا";
      break;
    case charter724GenderTypeItems[1]:
      result = "خانم";
      break;
    default:
      result = type;
      break;
  }
  return result;
};
export const convertFlyOrderStatusToText = (type) => {
  let result = "";
  switch (type) {
    case flyOrderStatusItems[0]:
      result = "در انتظار پرداخت";
      break;
    case flyOrderStatusItems[1]:
      result = "رزرو شده";
      break;
    case flyOrderStatusItems[2]:
      result = "پرداخت شده";
      break;
    case flyOrderStatusItems[3]:
      result = "لغو شده";
      break;
    case flyOrderStatusItems[4]:
      result = "در انتظار تایید ادمین";
      break;
    case flyOrderStatusItems[5]:
      result = "تایید شده توسط ادمین";
      break;
    case flyOrderStatusItems[6]:
      result = "رد شده توسط ادمین";
      break;
    default:
      result = type;
      break;
  }
  return result;
};
export const convertReceptionOrderStatusToText = (type) => {
  let result = "";
  switch (type) {
    case receptionOrderStatusItems[0]:
      result = "در انتظار پرداخت";
      break;
    case receptionOrderStatusItems[1]:
      result = "رزرو شده";
      break;
    case receptionOrderStatusItems[2]:
      result = "پرداخت شده";
      break;
    case receptionOrderStatusItems[3]:
      result = "لغو شده";
      break;
    case receptionOrderStatusItems[4]:
      result = "در انتظار تایید ادمین";
      break;
    case receptionOrderStatusItems[5]:
      result = "تایید شده توسط ادمین";
      break;
    case receptionOrderStatusItems[6]:
      result = "رد شده توسط ادمین";
      break;
    case receptionOrderStatusItems[7]:
      result = "در انتظار تایید نماینده";
      break;
    case receptionOrderStatusItems[8]:
      result = "تایید شده توسط نماینده";
      break;
    case receptionOrderStatusItems[9]:
      result = "رد شده توسط نماینده";
      break;
    case receptionOrderStatusItems[10]:
      result = "در انتظار تایید پذیرنده";
      break;
    case receptionOrderStatusItems[11]:
      result = "تایید شده توسط پذیرنده";
      break;
    case receptionOrderStatusItems[12]:
      result = "رد شده توسط پذیرنده";
      break;
    default:
      result = type;
      break;
  }
  return result;
};
export const convertCameraErrorToText = (type) => {
  let result = "";
  switch (type) {
    case cameraErrorItems[0]:
      result = "دسترسی به دوربین رد شده است";
      break;
    case cameraErrorItems[1]:
      result = "دوربینی یافت نشد";
      break;
    default:
      result = type;
      break;
  }
  return result;
};
export const convertPaymentTypeToText = (type) => {
  let result = "";
  switch (type) {
    case paymentTypeItems[0]:
      result = "درگاه پرداخت";
      break;
    case paymentTypeItems[1]:
      result = "نقدی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Convert To Text

//* Start Convert To Color
export const convertTicketTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case ticketTypeItems[0]:
      result = "warning";
      break;
    case ticketTypeItems[1]:
      result = "success";
      break;
    case ticketTypeItems[2]:
      result = "danger";
      break;

    default:
      break;
  }
  return result;
};
export const convertLogMethodToColor = (type) => {
  let result = "";
  switch (type) {
    case logMethodItems[0]:
      result = "primary";
      break;
    case logMethodItems[1]:
      result = "success";
      break;
    case logMethodItems[2]:
      result = "danger";
      break;
    case logMethodItems[3]:
      result = "warning";
      break;
    case logMethodItems[4]:
      result = "info";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertTransactionTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case transactionTypeItems[0]:
      result = "success";
      break;
    case transactionTypeItems[1]:
      result = "danger";
      break;
    case transactionTypeItems[2]:
      result = "primary";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertSnappTripBookStateToColor = (type) => {
  let result = "";
  switch (type) {
    case snappTripBookStateItems[0]:
      result = "info";
      break;
    case snappTripBookStateItems[1]:
      result = "success";
      break;
    case snappTripBookStateItems[2]:
      result = "success";
      break;
    case snappTripBookStateItems[3]:
      result = "danger";
      break;
    case snappTripBookStateItems[4]:
      result = "danger";
      break;
    case snappTripBookStateItems[5]:
      result = "warning";
      break;
    case snappTripBookStateItems[6]:
      result = "success";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertFlyOrderStatusToColor = (type) => {
  let result = "";
  switch (type) {
    case flyOrderStatusItems[0]:
      result = "warning";
      break;
    case flyOrderStatusItems[1]:
      result = "info";
      break;
    case flyOrderStatusItems[2]:
      result = "success";
      break;
    case flyOrderStatusItems[3]:
      result = "danger";
      break;
    case flyOrderStatusItems[4]:
      result = "secondary";
      break;
    case flyOrderStatusItems[5]:
      result = "success";
      break;
    case flyOrderStatusItems[6]:
      result = "danger";
      break;
    default:
      result = type;
      break;
  }
  return result;
};
export const convertReceptionOrderStatusToColor = (type) => {
  let result = "";
  switch (type) {
    case receptionOrderStatusItems[0]:
      result = "warning";
      break;
    case receptionOrderStatusItems[1]:
      result = "info";
      break;
    case receptionOrderStatusItems[2]:
      result = "success";
      break;
    case receptionOrderStatusItems[3]:
      result = "danger";
      break;
    case receptionOrderStatusItems[4]:
      result = "secondary";
      break;
    case receptionOrderStatusItems[5]:
      result = "success";
      break;
    case receptionOrderStatusItems[6]:
      result = "danger";
      break;
    case receptionOrderStatusItems[7]:
      result = "secondary";
      break;
    case receptionOrderStatusItems[8]:
      result = "success";
      break;
    case receptionOrderStatusItems[9]:
      result = "danger";
      break;
    case receptionOrderStatusItems[10]:
      result = "secondary";
      break;
    case receptionOrderStatusItems[11]:
      result = "success";
      break;
    case receptionOrderStatusItems[12]:
      result = "danger";
      break;
    default:
      result = type;
      break;
  }
  return result;
};
export const convertNotificationTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case notificationTypeItems[0]:
      result = "success";
      break;
    case notificationTypeItems[1]:
      result = "danger";
      break;
    case notificationTypeItems[2]:
      result = "info";
      break;
    case notificationTypeItems[3]:
      result = "warning";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertPaymentTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case paymentTypeItems[0]:
      result = "primary";
      break;
    case paymentTypeItems[1]:
      result = "secondary";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Convert To Color

//* Start Convert To Logo
export const convertCharter724AirlineToLogo = (type) => {
  let result = "/assets/images/airline-logos/";
  switch (type) {
    case charter724AirlineItems[0]:
      result += "VR.png";
      break;
    case charter724AirlineItems[1]:
      result += "ZV.png";
      break;
    case charter724AirlineItems[2]:
      result += "HH.png";
      break;
    case charter724AirlineItems[3]:
      result += "SA.png";
      break;
    case charter724AirlineItems[4]:
      result += "I3.png";
      break;
    case charter724AirlineItems[5]:
      result += "SR.png";
      break;
    case charter724AirlineItems[6]:
      result += "IV.png";
      break;
    case charter724AirlineItems[7]:
      result += "Y9.png";
      break;
    case charter724AirlineItems[8]:
      result += "IR.png";
      break;
    case charter724AirlineItems[9]:
      result += "JI.png";
      break;
    case charter724AirlineItems[10]:
      result += "EP.png";
      break;
    case charter724AirlineItems[11]:
      result += "B9.png";
      break;
    case charter724AirlineItems[12]:
      result += "W5.png";
      break;
    case charter724AirlineItems[13]:
      result += "AA.png";
      break;
    case charter724AirlineItems[14]:
      result += "RI.png";
      break;
    case charter724AirlineItems[15]:
      result += "FP.png";
      break;
    case charter724AirlineItems[16]:
      result += "QB.png";
      break;
    case charter724AirlineItems[17]:
      result += "PC.png";
      break;
    case charter724AirlineItems[18]:
      result += "NV.png";
      break;
    case charter724AirlineItems[19]:
      result += "PA.png";
      break;
    case charter724AirlineItems[20]:
      result += "yazdair.png";
      break;

    default:
      result += type;
      break;
  }
  return result;
};
//* End Convert To Logo
